<template>
  <div>
    <banner title="产品中心" text="上海沃时派客是国内领先的数字化包装供应链整合平台" imgUrl="https://manybox.oss-cn-shanghai.aliyuncs.com/officialWebsite/banner4.png"></banner>

    <div class="app-box">
      <div class="project-body">
        <ul>
          <li class="project-body-title">
            <p>沃时货运助手</p>
          </li>
          <li class="project-body-text">将货物的配送环节融入供应链管理的各个环节，并成为包装供应链管控的重要一环。结合司机端APP，客户、供应商和沃时可实时掌握物流运送信息，司机同时可成为从发货到收货全过程中的沟通保障</li>
          <li class="project-body-qrcode">
            <div>
              <div class="project-body-qrcode-title">
                <p class="iconfont iconAndroid"></p>
                <span>Android 版下载</span>
              </div>
              <img src="../../assets/platform/driverAndPad.png" alt="" width="128" height="128">
            </div>
            <!-- <div>
              <div class="project-body-qrcode-title">
                <p class="iconfont iconios"></p>
                <span>iPhone 版下载</span>
              </div>
              <img src="../../assets/platform/app_qrcode.png" alt="" width="128" height="128">
            </div> -->
          </li>
        </ul>
        <img width="528" src="../../assets/platform/app.png" alt="">
      </div>
    </div>
    <div class="weixin-box">
      <ul class="weixin-content">
        <li>
          <img src="../../assets/platform/weixin_gongyingshang.png" alt="" width="692">
          <div class="weixin-content-text">
            <p>沃时供应链助手</p>
            <span>打通上下游企业在平台匹配更合适的交易，降低仓储、物流、损耗、原材料成本，实现企业间的协同，协助企业为客户提供高品质服务</span>
            <img src="../../assets/platform/CSM.png" alt="" width="233">
          </div>
        </li>
        <li>
          <div class="weixin-content-text">
            <p>沃时包装助手</p>
            <span>助力企业搭建实时的数据分析包装供应链系统，已打通从询价到送货全过程，为客户提供了产品询价、产品报价、采购订单、打样订单、质检报告、预约送货、收货验货等功能。全链路协同协同增加效率，减少人工成本，提高企业运营效率</span>
            <img src="../../assets/platform/CSS.png" alt="" width="233">
          </div>
          <img src="../../assets/platform/weixin_kehu.png" alt="" width="692">
        </li>
      </ul>
    </div>
    <div class="backstageBox">
      <div class="box">
        <div class="left">
          <img src="@/assets/backstage.png">
        </div>
        <div class="right">
          <div class="title">沃时数据中台</div>
          <div class="text">自主研发沃时云制造（MES系统）和沃时货运助手（TMS系统），打通了企业与生产工厂间的信息孤岛，过程数据更实时化，同时掌握生产、库存和物流信息，提升企业间供需要求反应速度。以确保在供应链风险加剧的情况下，仍能满足企业对于供应保障的需求</div>
        </div>
      </div>
    </div>
    <div class="padBox">
      <div class="box">
        <div class="left">
          <div class="title">沃时云智造</div>
          <div class="text">自主研发沃时云制造（MES系统）和沃时货运助手（TMS系统），打通了企业与生产工厂间的信息孤岛，过程数据更实时化，同时掌握生产、库存和物流信息，提升企业间供需要求反应速度。以确保在供应链风险加剧的情况下，仍能满足企业对于供应保障的需求</div>
        </div>
        <div class="right">
          <img src="@/assets/home/pad.png">
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import banner from './banner.vue'

export default {
  components: {
    banner
  },
  data() {
    return {
      scrollTop: 0
    }
  },
  mounted() {
    this.position()
  },
  watch: {
    '$route': function (to) {
      if (to.path == '/platform') {
        this.position()
      }
    }
  },
  methods: {
    position() {
      if (this.$route.query.anchorPoint == 'backstage') {
        this.animation(2700)
      } else if (this.$route.query.anchorPoint == 'client') {
        this.animation(1888)
      } else if (this.$route.query.anchorPoint == 'supplier') {
        this.animation(1118)
      } else if (this.$route.query.anchorPoint == 'app') {
        this.animation(332)
      } else if (this.$route.query.anchorPoint == 'pad') {
        this.animation(3554)
      }
    },
    animation(val) {
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.scrollTop < val) {
            let tmp = val - this.scrollTop //剩余的
            this.scrollTop = this.scrollTop + (tmp > 100 ? 100 : tmp)
          }
          // if (this.scrollTop > val) {
          //   let tmp = this.scrollTop - val
          //   this.scrollTop = this.scrollTop - (tmp < 100 ? 100 : tmp)
          // }
          document.body.scrollTop = this.scrollTop
          document.documentElement.scrollTop = this.scrollTop
          this.scrollTop < val ? this.animation(val) : this.scrollTop = 0
          console.log(this.scrollTop, '-----');
        }, 10);
      })
    }
  },
}
</script>

<style scoped lang="less">
.app-box {
  background-color: #f8f8f8;
  overflow: hidden;
  min-width: 1200px;
}
// .project-title {
//   margin-top: 90px;
//   li:nth-child(1) {
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     color: #333333;
//     font-size: 32px;
//     p {
//       margin: 0 20px;
//       font-weight: bold;
//     }
//   }
//   li:nth-child(2) {
//     text-align: center;
//     font-size: 20px;
//     color: #999999;
//     margin-top: 10px;
//   }
// }
.project-body {
  width: 1200px;
  margin: 50px auto;
  display: flex;
  justify-content: space-between;
  .project-body-title {
    font-size: 36px;
    color: #333333;
    font-weight: 500;
    // font-weight: bold;
    // span {
    //   color: #02bca3;
    // }
  }
  .project-body-text {
    font-size: 18px;
    color: #666666;
    margin-top: 90px;
    width: 563px;
    line-height: 42px;
  }
  .project-body-qrcode {
    margin-top: 70px;
    display: flex;
    align-items: center;
    div {
      width: 202px;
      height: 202px;
      border-radius: 25px;
      background-color: #fff;
      margin-right: 24px;
      padding: 14px;
      .project-body-qrcode-title {
        padding: 0;
        display: flex;
        height: 40px;
        align-items: center;
        justify-content: center;
        color: #080808;
        p {
          font-size: 28px;
          margin-right: 10px;
        }
        span {
          font-size: 14px;
        }
      }
      img {
        display: block;
        margin: 10px auto 0;
      }
    }
  }
}
.weixin-box {
  overflow: hidden;
  min-width: 1200px;
  position: relative;
  &::before {
    content: "";
    width: 574px;
    height: 498px;
    background: url("../../assets/platform/bg2.png") no-repeat center;
    position: absolute;
    right: 0;
    top: 0;
    z-index: -1;
  }
  &::after {
    content: "";
    width: 100%;
    height: 1081px;
    background: url("../../assets/platform/bg1.png") no-repeat center;
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: -1;
  }
  .weixin-content {
    margin-top: 70px;
    li {
      display: flex;
      justify-content: center;
      margin-bottom: 95px;
      > img {
        margin: 0 20px;
      }
      .weixin-content-text {
        margin: 0 70px;
        p {
          font-size: 36px;
          color: #333;
          font-weight: 500;
          position: relative;
          height: 80px;
          &::before {
            content: "";
            width: 54px;
            height: 4px;
            background: #2062ae;
            position: absolute;
            bottom: 0;
            left: 0;
          }
        }
        span {
          display: block;
          font-size: 14px;
          line-height: 42px;
          color: #666666;
          margin-top: 40px;
          width: 491px;
        }
        img {
          margin-top: 95px;
        }
      }
    }
  }
}
.backstageBox {
  width: 100%;
  height: 827px;
  display: flex;
  justify-content: center;
  .box {
    width: 1200px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left {
      img {
        width: 679px;
        height: 419px;
      }
    }
    .right {
      width: 490px;
      .title {
        font-size: 36px;
        font-weight: 500;
        line-height: 42px;
        margin-bottom: 32px;
      }
      .text {
        font-size: 14px;
        line-height: 42px;
        color: #666666;
      }
    }
  }
}

.padBox {
  width: 100%;
  height: 785px;
  display: flex;
  justify-content: center;
  background-color: #f7f8fb;
  .box {
    width: 1200px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left {
      width: 490px;
      margin-right: 20px;
      .title {
        font-size: 36px;
        font-weight: 500;
        line-height: 42px;
        margin-bottom: 32px;
      }
      .text {
        font-size: 14px;
        line-height: 42px;
        color: #666666;
      }
    }
    .right {
      img {
        width: 626px;
        height: 391px;
        border: 8px solid;
        border-radius: 30px;
        box-shadow: -19px 24px 80px 1px rgba(0, 0, 0, 0.16);
      }
    }
  }
}
</style>